/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { GetClientConfigData } from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class Config<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags client-features-config-controller
   * @name GetClientConfig
   * @request GET:/config/feature-flags
   */
  getClientConfig = (params: RequestParams = {}) =>
    this.request<GetClientConfigData, any>({
      path: `/config/feature-flags`,
      method: "GET",
      format: "json",
      ...params,
    });
}
